import Product from '../../domains/Product'
import { IProductVariantOption } from '../../domains/ProductVariant'
import PubSub from '../PubSub'

interface PdpState {
  slug: string | null
  spid: number | null
  selectedOptions: IProductVariantOption[]
  bundleSelectedOptions: {
    product: Product
    selectedOptions: IProductVariantOption[]
  }[]
  reviewSectionInFocus: boolean
  seoPrice?: number | null
  productId?: string
  productTitle?: string
  createReviewPopUpSeen?: boolean
}

interface SetSelectedOptionsPayload {
  slug: string
  spid: number
  selectedOptions: IProductVariantOption[]
  bundleSelectedOptions?: {
    product: Product
    selectedOptions: IProductVariantOption[]
  }[]
  productId?: string
  productTitle?: string
}

class PdpStateManager extends PubSub {
  private state: PdpState
  private initialState: PdpState

  constructor() {
    super()
    this.initialState = {
      slug: null,
      spid: null,
      selectedOptions: [],
      bundleSelectedOptions: [],
      reviewSectionInFocus: false,
      seoPrice: null,
      productId: undefined,
      productTitle: undefined,
      createReviewPopUpSeen: false,
    }
    this.state = { ...this.initialState }
  }

  setSelectedOptions = (payload: SetSelectedOptionsPayload) => {
    this.state.slug = payload.slug
    this.state.spid = payload.spid
    this.state.selectedOptions = payload.selectedOptions
    this.state.bundleSelectedOptions = payload.bundleSelectedOptions ?? []
    this.state.productId = payload.productId
    this.state.productTitle = payload.productTitle
    this.publish()
  }

  setShowReviewSection = (payload: { reviewSectionInFocus: boolean }) => {
    this.state.reviewSectionInFocus = payload.reviewSectionInFocus
    this.publish()
  }

  setSeoPrice = (payload: { seoPrice: number }) => {
    this.state.seoPrice = payload.seoPrice
    this.publish()
  }

  setCreateReviewPopUpSeen = (payload: { createReviewPopUpSeen: boolean }) => {
    this.state.createReviewPopUpSeen = payload.createReviewPopUpSeen
    this.publish()
  }

  getSelectedOptions = () => {
    return this.state.selectedOptions
  }
  getBundleSelectedOptions = () => {
    return this.state.bundleSelectedOptions
  }
  getReviewSectionInFocus = () => {
    return this.state.reviewSectionInFocus
  }
  getSeoPrice = () => {
    return this.state.seoPrice
  }
  getProductSlugFromRedux = () => {
    return this.state.slug
  }
  getSpidFromRedux = () => {
    return this.state.spid
  }
  getProductIdFromRedux = () => {
    return this.state.productId
  }
  getProductTitleFromRedux = () => {
    return this.state.productTitle
  }
  getCreateReviewPopUpSeenFromRedux = () => {
    return this.state.createReviewPopUpSeen
  }

  override resetState = () => {
    this.state = {
      slug: null,
      spid: null,
      selectedOptions: [],
      bundleSelectedOptions: [],
      reviewSectionInFocus: false,
      seoPrice: null,
      productId: undefined,
      productTitle: undefined,
      createReviewPopUpSeen: this.state.createReviewPopUpSeen,
    }
    this.publish()
  }
}

const pdpStateManager: PdpStateManager = PdpStateManager.getInstance('pdpStateManager')

export default pdpStateManager
